import type { MatchDetailLocale } from './types'

import { z } from 'zod'

import { footballCoreBackTargetSchema, isSafeFootballCoreBackTarget } from '~/lib/navigation/football-core'
import { parsePublicFootballRouteInput } from '~/lib/public-football-read'

export type MatchDetailSearch = {
  back?: string
} & Record<string, unknown>

export function parseMatchDetailSearch(
  search: unknown,
  locale: MatchDetailLocale,
): MatchDetailSearch {
  return parsePublicFootballRouteInput(z.object({
    back: footballCoreBackTargetSchema(locale).optional(),
  }).passthrough(), search)
}
export function parseLocalizedMatchDetailSearch(search: unknown): MatchDetailSearch {
  return parsePublicFootballRouteInput(z.object({
    back: z.string().refine(
      value => isSafeFootballCoreBackTarget(value, 'en')
        || isSafeFootballCoreBackTarget(value, 'zh-CN'),
      'Expected a same-locale relative Football Core path',
    ).optional(),
  }).passthrough(), search)
}

export type LegacyRedirectSearchValidation
  = | { ok: true, search: string }
    | { ok: false }

export function validateLegacyRedirectSearch(
  search: string,
  locale: MatchDetailLocale,
): LegacyRedirectSearchValidation {
  const query = new URLSearchParams(search.startsWith('?') ? search.slice(1) : search)
  const backValues = query.getAll('back')
  if (backValues.length === 0)
    return { ok: true, search }
  if (backValues.length !== 1 || !isSafeFootballCoreBackTarget(backValues[0]!, locale))
    return { ok: false }
  return { ok: true, search }
}
